// entry-passage.model.ts

/**
 * Répartition horaire pour une entrée donnée.
 * Clé = créneau horaire (ex: "08h-09h"), valeur = nombre (ou % pour comparison)
 */
export interface EntryPassageHourlyBreakdown {
    [hourRange: string]: number;
}

/**
 * Répartition par entrée (porte) -> par créneau horaire
 * Clé = nom de l'entrée (ex: "Entree principale"), valeur = répartition horaire
 */
export interface EntryPassageByLevel {
    [entryName: string]: EntryPassageHourlyBreakdown;
}

/**
 * Données pour une période donnée (current ou versus)
 */
export interface EntryPassagePeriodData {
    nbPerson: number;
    nbGroups: number;
    nbVisitsByLevel: EntryPassageByLevel;
    nbGroupsByLevel: EntryPassageByLevel;
}

/**
 * Données de comparaison (variations en %) entre current et versus
 */
export interface EntryPassageComparisonData {
    nbPerson: number;
    nbGroups: number;
    nbVisitsByLevel: EntryPassageByLevel;
    nbGroupsByLevel: EntryPassageByLevel;
}

/**
 * Réponse complète de l'API entryPassageData
 */
export interface EntryPassageData {
    current: EntryPassagePeriodData;
    versus: EntryPassagePeriodData;
    comparison: EntryPassageComparisonData;
}
